import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviourService } from '../../../shared/services/behaviour.service';

@Component({
  selector: 'app-menubar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.css'],
})
export class MenuBarComponent {
  constructor(private router: Router, private behaviourService: BehaviourService) {}

  navigationToMapping() {
    this.router.navigateByUrl('/mapping');
  }

  navigationToOnboarding() {
    this.router.navigateByUrl('/customer-onboarding');
    this.behaviourService.sendArrayEvent([], '');
  }

  navigationTosearchAdress() {
    this.router.navigateByUrl('/search-adress');
  }

  navTocreateAddress() {
    this.router.navigate(['manage-address']);
  }

  navigationToEmailConfig() {
    this.router.navigateByUrl('email-configuration');
  }

  get isLoggedInUser() {
    return sessionStorage.getItem('isLoggedIn') == 'true';
  }

  get isInvoiceConfigs() {
    return sessionStorage.getItem('isCustomInvoice') === 'Custom';
  }

  get loosBbxConfig() {
    return sessionStorage.getItem('loose-bbx') === 'Yes';
  }

  navToPickupList() {
    this.router.navigateByUrl('/pickups');
  }

  navTocreateReports() {
    this.router.navigateByUrl('/reports');
  }
}
